export const isTokenExpired = (token: string): boolean => {
  if (!token) return true;
  try {
    const rawToken = token.replace(/^Bearer\s+/i, '');
    const base64Url = rawToken.split('.')[1];
    if (!base64Url) return true;
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const expiration = JSON.parse(atob(base64)).exp;
    return expiration * 1000 < Date.now();
  } catch {
    return true;
  }
};

export const logout = () => {
  if (typeof window === 'undefined') return;
  localStorage.removeItem('id_token');
};

export const isAuthenticated = () => {
  if (typeof window === 'undefined') return false;
  const token = localStorage.getItem('id_token');
  if (!token) return false;
  if (isTokenExpired(token)) {
    logout();
    return false;
  }
  return true;
};

export const isAuthenticatedV2 = (): { isAuthenticated: boolean; isTokenExpired: boolean } => {
  if (typeof window === 'undefined') return { isAuthenticated: false, isTokenExpired: false };
  const token = localStorage.getItem('id_token');
  if (!token) return { isAuthenticated: false, isTokenExpired: false };
  const expired = isTokenExpired(token);
  if (expired) {
    logout();
    return { isAuthenticated: false, isTokenExpired: true };
  }
  return { isAuthenticated: true, isTokenExpired: false };
};

export const handleSignIn = () => {
  window.localStorage.setItem('destination', window.location.href);
  return;
};

export const checkAuthentication = () => {
  const isLoggedIn = isAuthenticated();
  if (!isLoggedIn) {
    handleSignIn();
    window.location.href = '/profile/auth';
    return false;
  }
  return true;
};
